/**
 * @module:  黄豆页面映射
 * @author Liang Huang
 * @date 2020-09-15 10:32:47
 */
import { lazy } from 'react';
import { retry } from '@src/utils/tool';
import { initConfig, weChatFn } from '@src/utils/wechatShare.js';
import { isWeiXin } from '@src/utils/ua';
import { urlFn } from '@src/utils/index';

// 在线简历
export const OnlineResume = lazy(() => retry(() => import('@Resident/OnlineResume/index')));
// 编辑基础信息
export const EditBasicMsg = lazy(() => retry(() => import('@Resident/EditBasicMsg/index')));
// 编辑求职意向
export const JobIntension = lazy(() => retry(() => import('@Resident/JobIntension/index')));
// 添加和编辑工作经历
export const ResidentWorkExper = lazy(() => retry(() => import('@src/pages/Resident/WorkExper/index')));
// 添加和编辑项目经历
export const ResidentProjectExper = lazy(() => retry(() => import('@src/pages/Resident/ProjectExper/index')));
// 添加和编辑教育经历
export const ResidentEduExper = lazy(() => retry(() => import('@src/pages/Resident/EduExper/index')));
// 添加和编辑培训经历
export const ResidentTrainExper = lazy(() => retry(() => import('@src/pages/Resident/TrainExper/index')));
// 管理附件简历
export const AnnexResume = lazy(() => retry(() => import('@Resident/AnnexResume/index')));
// 上传附件简历
export const UploadResume = lazy(() => retry(() => import('@Resident/UploadResume/index')));
// 推荐候选人
export const RecommendPerson = lazy(() => retry(() => import('@Resident/RecommenPerson/index')));
// 推荐候选人电脑上传
export const ComputerUpload = lazy(() => retry(() => import('@src/pages/Resident/ComputerUpload/index')));
// 其他应用上传
export const OtherUpload = lazy(() => retry(() => import('@Resident/OtherUpload/index')));
// 推荐报告
export const RecommendReport = lazy(() => retry(() => import('@Resident/RecommendReport')));

export const RecommendUploadResume = lazy(() => retry(() => import('@Resident/RecommendUploadResume')));
export const LogoutProtocol = lazy(() => retry(() => import('@Resident/LogoutProtocol')));

// 我的投递
export const Delivery = lazy(() => retry(() => import('@Resident/Delivery')));
// 我的投递详情
export const DeliveryDetail = lazy(() => retry(() => import('@Resident/DeliveryDetail')));

export const JobDetail = lazy(() => retry(() => import('@Resident/JobDetail')));
export const CompanyDetail = lazy(() => retry(() => import('@Resident/CompanyDetail')));

const flag = urlFn.getFirstPathName();
// 判断是否是微信环境
if ((isWeiXin() && flag === 'resident') || flag === 'zhaopin') {
  initConfig();
  weChatFn();
}
